import React from "react";
import ConfigurationPage from "templates/ConfigurationPage";
import UserContent from "./UserContent";

const EditUser = (props) => {
 const {history} = props;
 
    return (
        <ConfigurationPage
            history={history}
            pageTitle="User"
            pageSubTitle="Edit user"
        >
            <ConfigurationPage.Content>
                <UserContent {...props}/>
            </ConfigurationPage.Content>
        </ConfigurationPage>
    );
};

export default EditUser;